import React from 'react';

const Disclaimer = () => (
  <section className="page">
    <h1>Disclaimer</h1>

    <h2>The Basics</h2>
    <p>
      Hestia Ledger’s my app—Blueprint Byte—a tool for tracking your finances, built from my own mess of 
      bankruptcy and scraping by. It’s simple, systematic, and yours to use, free or full version. But 
      here’s the deal: it’s “as-is.” I’m a normal guy, not a tech giant, so don’t expect perfection.
    </p>

    <h2>Data Risks</h2>
    <p>
      Your data’s in MongoDB—password’s encrypted, the rest isn’t. I don’t look at it, don’t sell it, 
      don’t run ads with it (check Privacy Policy). Still, it’s not Fort Knox—if it gets hacked or lost, 
      I’m not liable. Use it at your own risk, and back up anything you care about.
    </p>
    <h2>No Guarantees</h2>
<p>
  This site uses Google Analytics to see if anyone’s here, but that’s it—no fancy promises. The app 
  might glitch, might not fit your needs—I’m not on the hook for your losses. Free version’s a taste; 
  full version’s got more (Services page). Try it, but don’t sue me if it flops. 
  <a href="mailto:bell@hestialedger.com">Email me</a> if you’re stuck.
</p>

    <a href="http://app.hestialedger.com" className="cta-button">Try Now!</a>
  </section>
);

export default Disclaimer;